import { render, staticRenderFns } from "./EditRecommendationSettingDialog.vue?vue&type=template&id=6ec0cda9&"
import script from "./EditRecommendationSettingDialog.vue?vue&type=script&lang=js&"
export * from "./EditRecommendationSettingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports